import Noty from 'noty';

export const success = (message) => {
  new Noty({
    type: 'success',
    layout: 'bottomCenter',
    text: message,
    theme: 'metroui',
    progressBar: false,
    timeout: 2000,
  }).show();
};

export const error = (message = null) => {
  new Noty({
    type: 'error',
    layout: 'bottomCenter',
    text: message,
    theme: 'metroui',
    progressBar: false,
    timeout: 2000,
  }).show();
};
